import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { callActionJob, getActionJobs, getGroupServers, getListServers } from "services/ActionJobService";
import { handleError } from "utils/handleError";
import { ActionJobContext } from "./ActionJobContext";
import ModelCron from "./ModelCron";

export const ActionJobList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["action-job", "common", "user"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const statuses = [
        { label: t("action-job.statusNotActive"), value: 0 },
        { label: t("action-job.statusActive"), value: 1 },
        { label: t("action-job.statusPause"), value: 2 },
        { label: t("action-job.statusStop"), value: 3 },
        { label: t("action-job.statusNotActive"), value: null },
    ];

    const actionJobContext = useContext(ActionJobContext);
    const { actionJobs, setActionJobs, cronDialog, setCronDialog, actionJob, setActionJob, index, setIndex } = actionJobContext;

    const [dataSearch, setDataSearch] = useState({
        factoryName: null,
        ipServer: null,
    });
    const [groupServers, setGroupServers] = useState([]);
    const [listIpServers, setListIpServers] = useState([]);

    useEffect(() => {
        getGroupServers(headers)
            .then((res) => {
                setGroupServers(
                    res.data?.data?.map((el) => {
                        return { label: el, value: el };
                    })
                );
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        if (!!dataSearch.factoryName) {
            getListServers(headers, dataSearch.factoryName)
                .then((res) => {
                    setListIpServers(res.data?.data);
                })
                .catch((e) => {
                    console.log(e);
                });
        }
        setDataSearch({ ...dataSearch, ipServer: null });
        setListIpServers([]);
    }, [dataSearch.factoryName]);

    useEffect(() => {
        if (!!dataSearch.ipServer) {
            reloadActionJobs();
        } else {
            setActionJobs([]);
        }
    }, [dataSearch.ipServer]);

    const reloadActionJobs = () => {
        if (dataSearch.factoryName && dataSearch.ipServer) {
            const label = listIpServers?.find((e) => e.value === dataSearch.ipServer)?.label;
            getActionJobs(headers, { ...dataSearch, ipServer: label })
                .then((res) => {
                    setActionJobs(res.data?.data?.crons);
                })
                .catch((e) => {
                    console.log(e);
                });
        } else {
            setActionJobs([]);
        }
    };

    const searchOption = (
        <div className="grid">
            {/* nhóm công việc */}
            <div className="col-12 md:col-6">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="factoryName"
                    >
                        {t("action-job.factoryName")}
                    </label>
                    <Dropdown
                        className="col"
                        style={{
                            width: "calc(100% - 140px)",
                            margin: "5px 0px 0px 0px",
                        }}
                        showClear={true}
                        id="factoryName"
                        name="factoryName"
                        options={groupServers}
                        value={dataSearch.factoryName}
                        onChange={(e) => {
                            setDataSearch({
                                ...dataSearch,
                                factoryName: e.value,
                            });
                        }}
                    ></Dropdown>
                </div>
            </div>

            {/* server */}
            <div className="col-12 md:col-6">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="ipServer"
                    >
                        {t("action-job.ipServer")}
                    </label>
                    <Dropdown
                        className="col"
                        style={{
                            width: "100%",
                            // width: "calc(100% - 140px)",
                            margin: "5px 0px 0px 0px",
                        }}
                        showClear={true}
                        id="ipServer"
                        name="ipServer"
                        options={listIpServers}
                        value={dataSearch.ipServer}
                        onChange={(e) => {
                            setDataSearch({
                                ...dataSearch,
                                ipServer: e.value,
                            });
                        }}
                    ></Dropdown>
                </div>
            </div>
        </div>
    );

    const template = (options) => {
        const toggleIcon = options.collapsed ? "pi pi-chevron-down" : "pi pi-chevron-up";
        const className = `${options.className} justify-content-start`;
        const titleClassName = `${options.titleClassName} pl-1`;

        return (
            <div className={className}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <span className={titleClassName}>Header</span>
            </div>
        );
    };

    const clickJob = (data) => {
        let action = null;
        if (data?.status === 0 || data?.status === 3) {
            action = "START";
        } else if (data?.status === 1) {
            action = "PAUSE";
        } else if (data?.status === 2) {
            action = "RESUME";
        } else if (data?.status !== 0 && data?.status !== 3) {
            action = "DELETE";
        }
        const label = listIpServers?.find((e) => e.value === dataSearch.ipServer)?.label;
        const req = {
            factoryName: data?.groupName,
            jobClass: data.jobClass,
            cronExpression: data?.cronExpression,
            action,
            ipServer: label,
        };

        callActionJob(headers, req)
            .then((res) => {
                if (res.data?.code === 200) {
                    toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("action-job.updateActive", { object: t("success", { ns: "common" }) }), life: 3000 });
                    reloadActionJobs();
                } else {
                    toast.current.show({ severity: "error", summary: t("error", { ns: "common" }), detail: res.data?.message, life: 3000 });
                }
            })
            .catch((error) => handleError(toast, t, error));
    };

    const getLabelActionJob = (data) => {
        if (data.status === 0 || data.status === 3) {
            return t("action-job.start");
        } else if (data.status === 1) {
            return t("action-job.pause");
        } else if (data.status === 2) {
            return t("action-job.resume");
        } else if (data.status !== 0 && data.status !== 3) {
            return t("action-job.delete");
        }
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("action-job.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12">
                            {actionJobs?.length > 0 && (
                                <BlockDetail title={t("action-job.list")}>
                                    <Toast ref={toast} />
                                    <div className="grid">
                                        {actionJobs?.map((el, i) => {
                                            return (
                                                <div key={i} className="col-12">
                                                    <Panel template={template} header={el?.job?.moTa} toggleable collapsed={false}>
                                                        <div className="grid">
                                                            <div className="col-12">
                                                                <div className="grid">
                                                                    <div className="col-4">
                                                                        <div className="grid">
                                                                            <label
                                                                                className="col-fixed text-center"
                                                                                style={{
                                                                                    width: "130px",
                                                                                    justifyContent: "end",
                                                                                    display: "flex",
                                                                                    padding: "0.75rem 0px 0px 0px",
                                                                                }}
                                                                                htmlFor="cronExpression"
                                                                            >
                                                                                {t("action-job.cronExpression")}
                                                                            </label>
                                                                            <div className="col">
                                                                                <InputText
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    id={`cronExpression_${i}`}
                                                                                    name={`cronExpression_${i}`}
                                                                                    value={el.job?.cronExpression}
                                                                                    readOnly
                                                                                    // disabled
                                                                                    onClick={(e) => {
                                                                                        setIndex(i);
                                                                                        setActionJob(el);
                                                                                        setCronDialog(true);
                                                                                    }}
                                                                                ></InputText>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <div className="grid">
                                                                            <label
                                                                                className="col-fixed text-center"
                                                                                style={{
                                                                                    width: "130px",
                                                                                    justifyContent: "end",
                                                                                    display: "flex",
                                                                                    padding: "0.75rem 0px 0px 0px",
                                                                                }}
                                                                                htmlFor="status"
                                                                            >
                                                                                {t("action-job.status")}
                                                                            </label>
                                                                            <div className="col">
                                                                                <InputText
                                                                                    style={{
                                                                                        width: "100%",
                                                                                    }}
                                                                                    id={`status_${i}`}
                                                                                    name={`status_${i}`}
                                                                                    value={statuses.find((x) => x.value === el.job.status)?.label}
                                                                                    readOnly
                                                                                ></InputText>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <Button
                                                                            label={getLabelActionJob(el?.job)}
                                                                            onClick={(e) => {
                                                                                clickJob(el?.job);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Panel>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </BlockDetail>
                            )}
                        </div>
                        <div className="col-12">
                            <ModelCron />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
